// Iris homepage — scroll parallax on floating cards
(function() {
    function init() {
        var container = document.getElementById("irisParallax");
        if (!container) return;
        var floats = container.querySelectorAll(".iris-float");
        if (!floats.length) return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        var ticking = false;
        function update() {
            var rect = container.getBoundingClientRect();
            var vh = window.innerHeight || document.documentElement.clientHeight;
            // How far the container's center is from the viewport center, normalized.
            var containerCenter = rect.top + rect.height / 2;
            var offsetFromCenter = (vh / 2 - containerCenter) / vh; // -1..1 roughly
            floats.forEach(function(el) {
                var speed = parseFloat(el.getAttribute("data-speed")) || 0.5;
                // Up to ~120px of drift, scaled by each card's speed
                var shift = offsetFromCenter * 120 * speed;
                el.style.transform = "translateY(" + shift.toFixed(1) + "px)";
            });
            ticking = false;
        }
        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        window.addEventListener("resize", onScroll, {
            passive: true
        });
        update();
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
    else init();
})();

//# sourceMappingURL=index.80b0fe3c.js.map
